import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { CoreCommonModule } from '@core/common.module';
import { Router, RouterModule, Routes } from '@angular/router';
import { ListClientsComponent } from './list-clients/list-clients.component';
import { TrenditAppsComponent } from './trendit-apps.component';
import { NosAppsComponent } from './nos-apps/nos-apps.component';
import { HeaderComponent } from './header/header.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';

const routes = [
    {
      path: '',
      component: TrenditAppsComponent,
    },
];
@NgModule({
  declarations: [
    TrenditAppsComponent,
    ListClientsComponent,
    NosAppsComponent,
    HeaderComponent,
    ContactComponent,
    
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    NgSelectModule,
    FormsModule,
    FooterComponent
],

  providers: []
})
export class TrenditAppsModule {}
